import script from "./PropertyPublishResume.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyPublishResume.vue?vue&type=script&setup=true&lang=js"

import "./PropertyPublishResume.vue?vue&type=style&index=0&id=6f25ce16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f25ce16"]])

export default __exports__